module.exports = __webpack_public_path__ + "static/media/zendesk.0f2d6ae6.svg";